import BulkUploadPage from "@faire/prototype-playground/workspace/hd/bulk-upload";
import ShopifyBestsellerNudgePage from "@faire/prototype-playground/workspace/hd/shopify-bestseller-nudge";
import { ShopifyImportSessionHost } from "@faire/prototype-playground/workspace/hd/shopify-bestseller-nudge/ShopifyImportSessionHost";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const CCBulkUploadPage = lazy(
  () => import("../../workspace/hd/shopify-bestseller-nudge/CCBulkUploadPage")
);
const BulkEditorPlaceholderPage = lazy(
  () =>
    import(
      "../../workspace/hd/shopify-bestseller-nudge/BulkEditorPlaceholderPage"
    )
);
const CCProductsPage = lazy(
  () => import("../../workspace/hd/shopify-bestseller-nudge/CCProductsPage")
);
const CCSingleProductEditorPage = lazy(
  () =>
    import(
      "../../workspace/hd/shopify-bestseller-nudge/CCSingleProductEditorPage"
    )
);

export function HarshdipSinghDeoganRoutes() {
  return (
    <>
      <ShopifyImportSessionHost />
      <Switch>
        <Route path="/hd/bulk-upload" component={BulkUploadPage} />
        <Route
          path="/hd/shopify-bestseller-nudge/bulk-editor"
          component={BulkEditorPlaceholderPage}
        />
        <Route
          path="/hd/shopify-bestseller-nudge/bulk-upload"
          component={CCBulkUploadPage}
        />
        <Route
          path="/hd/shopify-bestseller-nudge/products"
          component={CCProductsPage}
        />
        <Route
          path="/hd/shopify-bestseller-nudge/spe"
          component={CCSingleProductEditorPage}
        />
        <Route
          path="/hd/shopify-bestseller-nudge"
          component={ShopifyBestsellerNudgePage}
        />
      </Switch>
    </>
  );
}

export const slug = "hd";
